import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './StitchingtaskAPI';
import {getColumns} from './StitchingtaskStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getStitchingtaskView} from './StitchingtaskView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteStitchingtaskObj  ,setSelectedStitchingtaskId,setStitchingtaskCollectWorkModal,
  setSelectedActionId , 
setShowEditForStitchingtask,setStitchingtaskEditRateModal,setStitchingtaskUpdateWorkerModal} from 'store/slice/ManufSlice';

import StitchingtaskListTable from './components/StitchingtaskListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import StitchingtaskFilterCriteriaImpl from './StitchingtaskFilterCriteriaImpl';

import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PersonIcon from '@mui/icons-material/Person';
import SwipeUpAltIcon from '@mui/icons-material/SwipeUpAlt';
import EditRateActionModal from './action/EditRate/EditRateActionModal';

import CollectWorkActionModal from './action/CollectWork/CollectWorkActionModal';
import UpdateWorkerActionModal from './action/UpdateWorker/UpdateWorkerActionModal';

import { transformDateValue } from 'core/js/FormUtils';

export default function StitchingtaskListImpl( {tableList, cardList, setShowEdit, setStitchingtaskId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, stitchingtaskObj} = useSelector((state)=>state.manufslice.stitchingtaskDashboard);
  const { stitchingtaskList } = useSelector((state) => state.manufslice.stitchingtaskDashboard);

  const {UpdateStatusModalOpen} = useSelector((state) => state.manufslice.taskinstanceDashboard);
  

  useEffect(() => {
  }, [stitchingtaskList, stitchingtaskObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedStitchingtaskId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteStitchingtaskObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedStitchingtaskId(id));
    dispatch(setShowEditForStitchingtask(true));
  }
  
  const createStitchingtask=()=>{
    dispatch(setSelectedStitchingtaskId(-1));
    dispatch(setShowEditForStitchingtask(true));
  }
  const EditRateCallBack = (id) =>{
      dispatch(setSelectedStitchingtaskId(id));
      dispatch(setStitchingtaskEditRateModal(true));
    }
const UpdateWorkerCallBack = (id) =>{
    dispatch(setSelectedStitchingtaskId(id));
    dispatch(setStitchingtaskUpdateWorkerModal(true));
  }

  const CollectWorkCallBack = (id) =>{
    dispatch(setSelectedStitchingtaskId(id));
    dispatch(setStitchingtaskCollectWorkModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const stitchingtaskTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    stitchingtaskList:stitchingtaskList,
    cardList:getStitchingtaskView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:108, title:'Collect Work', callBackMethod:CollectWorkCallBack, icon:<SwipeUpAltIcon/>, status:'Draft', role:''},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:stitchingtaskTransformation(tableList),
      stitchingtaskList:stitchingtaskList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        {id:108, title:'Collect Work', callBackMethod:CollectWorkCallBack, icon:<SwipeUpAltIcon/>, status:'Draft', role:''},
        {id:111, title:'Edit Rate', callBackMethod:EditRateCallBack, icon:<CurrencyRupeeIcon/>, status:'Draft', role:''},
        {id:112, title:'Update Worker', callBackMethod:UpdateWorkerCallBack, icon:<PersonIcon/>, status:'Draft', role:''},
      ]
    }
  }
  
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item lg={12} sx={{ width: '100%',}}>
                  <Grid container direction="row" justifyContent="space-between" alignContent="center" sx={{maxHeight:'90vh', p:1}}>
                      <Grid item lg={3} sx={{alignText:'center'}}>
                        <Typography variant='h4' color="primary.darker">Stitching Task(s)</Typography>
                      </Grid>
                      {!UpdateStatusModalOpen && (
                      <Grid item lg={8}>
                      < StitchingtaskFilterCriteriaImpl  />
                      </Grid>
                      )}
                      
                      <Grid item lg={1}>
                        <Grid container justifyContent={'flex-end'}>
                          {UpdateStatusModalOpen?<Grid item>
                              <Tooltip title="Add Stitchingtask" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createStitchingtask()}}/>
                              </Tooltip>
                            </Grid>:
                            <>
                            </>}
                         </Grid>
                      </Grid>
                    </Grid>
              </Grid>
              <Grid item>
                < StitchingtaskListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<CollectWorkActionModal/>
<EditRateActionModal/>
<UpdateWorkerActionModal/>
    </>
);


}